import { useDispatch } from "react-redux";
import type { AppDispatchType } from "../types/dispatch.types";

export const useAppDispatch = () => useDispatch<AppDispatchType>();
